import React from 'react';
import styles from './History.module.scss';

const History = () => {
  return (
    <div className={styles.history}>
      <h2>История</h2>
      <p>
        Институт города был создан в 2020 как региональный центр по вопросам планирования пространственного,
        архитектурно-градостроительного развития и комплексного благоустройства территорий муниципальных образований
        Красноярского края.
      </p>
      <p>
        Учредителями Института выступают ФГАОУ ВО «Сибирский федеральный университет», Красноярский край в лице
        министерства строительства Красноярского края и Муниципальное образование городской округ город Красноярск
        Красноярского края в лице Администрации города Красноярска.
      </p>
      <p>
        В соответствии с Постановлением Правительства Красноярского края от 17.12.2020 № 887-п Институт осуществляет
        функции регионального центра компетенций по вопросам городской среды на территории муниципальных образований
        Красноярского края.
      </p>
      <p>
        В рамках своей уставной деятельности, включая нормативно-методическое содействие муниципальным образованиям
        Красноярского края, Институт выступает:
        <span>
          заказчиком разработки концепций благоустройства и проектно-сметной документации по благоустройству
          общественных пространств на территории муниципальных образований края в рамках реализации федерального проекта
          «Формирование комфортной городской среды», концепций и стандартов благоустройства, айдентики населённых
          пунктов, мастер-планов комплексного развития муниципальных образований и иных территорий;
        </span>
        <span>
          разработчиком проектов благоустройства общественных пространств и иных объектов, расположенных на территории
          муниципальных образований края, методических и адресных рекомендаций по различным направлениям, касающимся
          вопросов благоустройства и архитектурно-художественного облика;
        </span>
        <span>
          заказчиком разработки документов (регламентов, стандартов, типовых решений) по формированию комфортной среды и
          улучшению архитектурно-художественного облика населённых пунктов;
        </span>
        <span>
          оператором архитектурных, архитектурно-градостроительных, архитектурно-художественных и иных творческих
          конкурсов;
        </span>
        <span>
          экспертом по оценке проектов, разработанных в рамках государственных и региональных программ (конкурсов,
          грантов), при реализации которых планируется использование средств бюджетов различного уровня;
        </span>
        <span>
          постоянно действующей дискуссионной площадкой по экспертному рассмотрению значимых для города Красноярска и
          Красноярского края вопросов городского развития, вовлечению в обсуждение городских преобразований бизнеса,
          местных жителей и локальных сообществ;
        </span>
        <span>
          образовательной площадкой, действующей в целях повышения профессионального уровня муниципальных служащих и
          иных заинтересованных лиц, которая функционирует на основе взаимодействия с высококвалифицированными
          экспертами Красноярского края и иных регионов Российской Федерации.
        </span>
      </p>
    </div>
  );
};

export default History;
